import { UPDATE_CUSTOMER_DETAILS } from 'constants/customerDetails';

const INITIAL_STATE = {};

const customerDetails = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_DETAILS:
      return { ...action.customerDetails };
    default:
      return state;
  }
};

export default customerDetails;
